import { isArray as p, isEqual as ii } from "../util/code-utils.js";
import ei from "../models/push-token.js";
import r from "../../shared-lib/braze-shared-lib.js";
import { STORAGE_KEYS as o } from "../managers/storage-manager.js";
import { User } from "../User/index.js";
import { WindowUtils as H } from "../util/window-utils.js";
import dt from "./utils/push-utils.js";
export default class aa {
  constructor(i, e, t, s, r, n, o, u, a, c) {
    (this.Sr = i),
      (this._r = e),
      (this.Ur = t),
      (this.Wr = s + "/safari/" + e),
      (this.Vr = r || "/service-worker.js"),
      (this.Or = n),
      (this.gt = o),
      (this.Yr = u || !1),
      (this.Gr = a || !1),
      (this.h = c),
      (this.Hr = dt.Jr()),
      (this.Kr = dt.Lr());
  }
  Qr() {
    return this.Gr;
  }
  Xr(i, e, t, s, n) {
    i.unsubscribe()
      .then(i => {
        i
          ? this.Zr(e, t, s, n)
          : (r.D.error("Failed to unsubscribe device from push."),
            "function" == typeof n && n(!1));
      })
      .catch(i => {
        r.D.error("Push unsubscription error: " + i),
          "function" == typeof n && n(!1);
      });
  }
  sn(i, e, t) {
    const s = (i => {
      if ("string" == typeof i) return i;
      if (0 !== i.endpoint.indexOf("https://android.googleapis.com/gcm/send"))
        return i.endpoint;
      let e = i.endpoint;
      return (
        i.rn &&
          -1 === i.endpoint.indexOf(i.rn) &&
          (e = i.endpoint + "/" + i.rn),
        e
      );
    })(i);
    let r = null,
      n = null;
    if (null != i.getKey)
      try {
        (r = btoa(
          String.fromCharCode.apply(null, new Uint8Array(i.getKey("p256dh")))
        )),
          (n = btoa(
            String.fromCharCode.apply(null, new Uint8Array(i.getKey("auth")))
          ));
      } catch (i) {
        if ("invalid arguments" !== i.message) throw i;
      }
    const o = (i => {
      let e;
      return i.options &&
        (e = i.options.applicationServerKey) &&
        e.byteLength &&
        e.byteLength > 0
        ? btoa(String.fromCharCode.apply(null, new Uint8Array(e)))
            .replace(/\+/g, "-")
            .replace(/\//g, "_")
        : null;
    })(i);
    this.Sr.on(s, t, r, n, o), s && "function" == typeof e && e(s, r, n);
  }
  un() {
    this.Sr.an(!0);
  }
  cn(i, e) {
    this.Sr.an(!1), r.D.info(i), "function" == typeof e && e(!1);
  }
  hn(i, e, t, s) {
    if ("default" === e.permission)
      try {
        window.safari.pushNotification.requestPermission(
          this.Wr,
          i,
          { api_key: this._r, device_id: this.Ur.te().id },
          e => {
            "granted" === e.permission &&
              this.Sr.setPushNotificationSubscriptionType(
                User.NotificationSubscriptionTypes.OPTED_IN
              ),
              this.hn(i, e, t, s);
          }
        );
      } catch (i) {
        this.cn("Could not request permission for push: " + i, s);
      }
    else
      "denied" === e.permission
        ? this.cn(
            "The user has blocked notifications from this site, or Safari push is not configured in the Braze dashboard.",
            s
          )
        : "granted" === e.permission &&
          (r.D.info("Device successfully subscribed to push."),
          this.sn(e.deviceToken, t, new Date()));
  }
  fn(i, e, t) {
    const s = s => {
      switch (s) {
        case "granted":
          return void ("function" == typeof i && i());
        case "default":
          return void ("function" == typeof e && e());
        case "denied":
          return void ("function" == typeof t && t());
        default:
          r.D.error("Received unexpected permission result " + s);
      }
    };
    let n = !1;
    const o = window.Notification.requestPermission(i => {
      n && s(i);
    });
    o
      ? o.then(i => {
          s(i);
        })
      : (n = !0);
  }
  Zr(i, e, t, s) {
    const n = { userVisibleOnly: !0 };
    null != e && (n.applicationServerKey = e),
      i.pushManager
        .subscribe(n)
        .then(i => {
          r.D.info("Device successfully subscribed to push."),
            this.sn(i, t, new Date());
        })
        .catch(i => {
          dt.isPushBlocked()
            ? (r.D.info("Permission for push notifications was denied."),
              "function" == typeof s && s(!1))
            : (r.D.error("Push subscription failed: " + i),
              "function" == typeof s && s(!0));
        });
  }
  ln() {
    return this.Yr
      ? navigator.serviceWorker.getRegistration()
      : navigator.serviceWorker.register(this.Vr).then(() =>
          navigator.serviceWorker.ready.then(
            i => (
              i &&
                "function" == typeof i.update &&
                i.update().catch(i => {
                  r.D.info("ServiceWorker update failed: " + i);
                }),
              i
            )
          )
        );
  }
  dn(i) {
    this.Yr ||
      (i.unregister(), r.D.info("Service worker successfully unregistered."));
  }
  subscribe(i, e) {
    if (!dt.isPushSupported())
      return r.D.info(aa.pn), void ("function" == typeof e && e(!1));
    if (this.Hr) {
      if (!this.Yr && null != window.location) {
        let i = this.Vr;
        -1 === i.indexOf(window.location.host) &&
          (i = window.location.host + i),
          -1 === i.indexOf(window.location.protocol) &&
            (i = window.location.protocol + "//" + i);
        const t = i.substr(0, i.lastIndexOf("/") + 1);
        if (0 !== H.bn().indexOf(t))
          return (
            r.D.error(
              "Cannot subscribe to push from a path higher than the service worker location (tried to subscribe from " +
                window.location.pathname +
                " but service worker is at " +
                i +
                ")"
            ),
            void ("function" == typeof e && e(!0))
          );
      }
      if (dt.isPushBlocked())
        return void this.cn(
          "Notifications from this site are blocked. This may be a temporary embargo or a permanent denial.",
          e
        );
      if (this.gt && !this.gt.mn() && 0 === this.gt.Zs())
        return (
          r.D.info(
            "Waiting for VAPID key from server config before subscribing to push."
          ),
          void this.gt.gn(() => {
            this.subscribe(i, e);
          })
        );
      const t = () => {
          r.D.info("Permission for push notifications was denied."),
            "function" == typeof e && e(!1);
        },
        s = () => {
          let i = "Permission for push notifications was ignored.";
          dt.isPushBlocked() &&
            (i +=
              " The browser has automatically blocked further permission requests for a period (probably 1 week)."),
            r.D.info(i),
            "function" == typeof e && e(!0);
        },
        n = dt.isPushPermissionGranted(),
        u = () => {
          n ||
            this.Sr.setPushNotificationSubscriptionType(
              User.NotificationSubscriptionTypes.OPTED_IN
            ),
            this.ln()
              .then(t => {
                if (null == t)
                  return (
                    r.D.error(
                      "No service worker registration. Set the `manageServiceWorkerExternally` initialization option to false or ensure that your service worker is registered before calling registerPush."
                    ),
                    void ("function" == typeof e && e(!0))
                  );
                t.pushManager
                  .getSubscription()
                  .then(s => {
                    let n = null;
                    if (
                      (this.gt &&
                        null != this.gt.mn() &&
                        (n = r.yn.wn(this.gt.mn())),
                      s)
                    ) {
                      let u = null,
                        a = null;
                      const c = this.h.I(o.q.vn);
                      if (c && !p(c)) {
                        let i;
                        try {
                          i = ei.Pn(c).kn;
                        } catch (e) {
                          i = null;
                        }
                        null == i ||
                          isNaN(i.getTime()) ||
                          0 === i.getTime() ||
                          ((u = i),
                          (a = new Date(u)),
                          a.setMonth(u.getMonth() + 6));
                      }
                      null != n &&
                      s.options &&
                      s.options.applicationServerKey &&
                      s.options.applicationServerKey.byteLength &&
                      s.options.applicationServerKey.byteLength > 0 &&
                      !ii(n, new Uint8Array(s.options.applicationServerKey))
                        ? (s.options.applicationServerKey.byteLength > 12
                            ? r.D.info(
                                "Device was already subscribed to push using a different VAPID provider, creating new subscription."
                              )
                            : r.D.info(
                                "Attempting to upgrade a gcm_sender_id-based push registration to VAPID - depending on the browser this may or may not result in the same gcm_sender_id-based subscription."
                              ),
                          this.Xr(s, t, n, i, e))
                        : s.expirationTime &&
                          new Date(s.expirationTime) <= new Date().valueOf()
                        ? (r.D.info(
                            "Push subscription is expired, creating new subscription."
                          ),
                          this.Xr(s, t, n, i, e))
                        : c && p(c)
                        ? this.Xr(s, t, n, i, e)
                        : null == a
                        ? (r.D.info(
                            "No push subscription creation date found, creating new subscription."
                          ),
                          this.Xr(s, t, n, i, e))
                        : a <= new Date().valueOf()
                        ? (r.D.info(
                            "Push subscription older than 6 months, creating new subscription."
                          ),
                          this.Xr(s, t, n, i, e))
                        : (r.D.info(
                            "Device already subscribed to push, sending existing subscription to backend."
                          ),
                          this.sn(s, i, u));
                    } else this.Zr(t, n, i, e);
                  })
                  .catch(i => {
                    r.D.error(
                      "Error checking current push subscriptions: " + i
                    );
                  });
              })
              .catch(i => {
                r.D.error("ServiceWorker registration failed: " + i);
              });
        };
      this.fn(u, s, t);
    } else if (this.Kr) {
      if (null == this.Or || "" === this.Or)
        return (
          r.D.error(
            "You must supply the safariWebsitePushId initialization option in order to use registerPush on Safari"
          ),
          void ("function" == typeof e && e(!0))
        );
      const t = window.safari.pushNotification.permission(this.Or);
      this.hn(this.Or, t, i, e);
    }
  }
  unsubscribe(i, e) {
    if (!dt.isPushSupported())
      return r.D.info(aa.pn), void ("function" == typeof e && e());
    this.Hr
      ? navigator.serviceWorker.getRegistration().then(t => {
          t
            ? t.pushManager
                .getSubscription()
                .then(s => {
                  s &&
                    (this.un(),
                    s
                      .unsubscribe()
                      .then(s => {
                        s
                          ? (r.D.info(
                              "Device successfully unsubscribed from push."
                            ),
                            "function" == typeof i && i())
                          : (r.D.error(
                              "Failed to unsubscribe device from push."
                            ),
                            "function" == typeof e && e()),
                          this.dn(t);
                      })
                      .catch(i => {
                        r.D.error("Push unsubscription error: " + i),
                          "function" == typeof e && e();
                      }));
                })
                .catch(i => {
                  r.D.error("Error unsubscribing from push: " + i),
                    "function" == typeof e && e();
                })
            : (r.D.info("Device already unsubscribed from push."),
              "function" == typeof i && i());
        })
      : this.Kr &&
        (this.un(),
        r.D.info("Device unsubscribed from push."),
        "function" == typeof i && i());
  }
}
aa.pn = "Push notifications are not supported in this browser.";
